import {
	Box /* , ImageList, ImageListItem*/,
	Collapse,
	Stack,
	Typography
} from "@mui/material";
import { useEffect, useState } from "react";

import { isMobile } from "react-device-detect";
import { ColorScheme } from "../../Themes/ColorScheme";
import { Spinner } from "../Common/Spinner";
import { ClientOrderCard } from "./ClientOrderCard";

import { useTranslation } from "react-i18next";
import "./Transitions.css";

export const ClientCard = ({ user, isLast, setDialogUser }) => {
	const { t } = useTranslation();

	const [cardOpen /* setCardOpen */] = useState(false); // todo id identifier
	const [orders /* setOrders */] = useState([]);
	const [successful, setSuccessful] = useState(true);
	const [, /* selectedOrder */ setSelectedOrder] = useState(null);
	const [isLoading /* setIsLoading */] = useState(false);

	const handleSelectOrder = (props) => {
		setSelectedOrder(props);
	};

	useEffect(() => {
		if (user.unpaid_orders) setSuccessful(false);
	}, []);

	return (
		<Box
			onClick={() => setDialogUser(user)}
			sx={{
				backgroundColor: cardOpen
					? ColorScheme.secondary
					: ColorScheme.secondary,
				height: "80px",
				cursor: "pointer",
				borderBottom: !isLast && "1px solid " + ColorScheme.lightGrey, 
				display: "flex",
				flexDirection: "row",
				alignItems: "center",
				":hover": {
					backgroundColor: ColorScheme.lightGrey
				}
			}}
		>
			<Box
				sx={{
					width: !isMobile ? "calc(100% / 4)" : "calc(100% / 2)",
					px: "20px",
					boxSizing: "border-box"
				}}
			>
				<Typography
					sx={{
						fontSize: isMobile ? "12px" : "16px",
						fontWeight: "700",
						color: ColorScheme.black
					}}
				>
					{user.name}
				</Typography>
				{isMobile && (
					<Typography sx={{ fontSize: 10, color: ColorScheme.darkGrey }}>
						{user?.email}
					</Typography>
				)}
			</Box>

			{!isMobile ? (
				<>
					<Box
						sx={{
							width: "calc(100% / 4)",
							px: "20px",
							boxSizing: "border-box"
						}}
					>
						<Typography
							sx={{
								color: ColorScheme.black,
								fontSize: "12px",
								wordWrap: "break-word",
								wordBreak: "break-all"
							}}
						>
							{user?.email}
						</Typography>
					</Box>
				</>
			) : (
				<></>
			)}

			{!isMobile && (
				<Box
					sx={{
						width: "calc(100% / 4)",
						px: "20px",
						boxSizing: "border-box"
					}}
				>
					<Typography
						sx={{
							color: ColorScheme.black,
							fontSize: "12px"
						}}
					>
						{user.order_count === 1
							? +user.order_count +
								" " +
								t("orders.single_purchase_label")
							: user.order_count +
								" " +
								t("orders.multiple_purchases_label")}
					</Typography>
				</Box>
			)}
			<Box
				sx={{
					width: isMobile ? "calc(100% / 2)" : "calc(100% / 4)",
					px: "20px",
					boxSizing: "border-box",
					display: "flex",
					flexDirection: "row",
					alignItems: "center",
					justifyContent: "flex-end"
				}}
			>
				{isMobile && (
					<Typography
						sx={{
							color: ColorScheme.black,
							fontSize: "12px",
							marginRight: "20px"
						}}
					>
						{user.order_count === 1
							? +user.order_count +
								" " +
								t("orders.single_purchase_label")
							: user.order_count +
								" " +
								t("orders.multiple_purchases_label")}
					</Typography>
				)}
				<div
					style={{
						float: "right",
						backgroundColor: successful ? ColorScheme.successPrimary : ColorScheme.dangerPrimary,
						height: 12,
						width: 12,
						borderRadius: 99
					}}
				/>
			</Box>

			<Collapse
				in={cardOpen}
				timeout={500}
				easing
			>
				<div
					style={{
						// divider bar
						height: "1px",
						width: "100%",
						backgroundColor: ColorScheme.lightGrey,
						marginTop: "20px",
						display: !cardOpen && "none"
					}}
				/>
				<div style={{ display: !cardOpen && "none" }}>
					<Stack
						sx={{
							flexDirection: "row",
							display: "flex",
							paddingX: isMobile ? "10px" : "30px",
							paddingY: "10px",
							alignItems: "center",
							border: "1px solid transparent"
						}}
					>
						<Stack sx={{ flex: 1 }}>
							<Typography
								sx={{
									fontSize: "11px",
									color: ColorScheme.black,
									fontWeight: "700"
									//  minWidth: "72px"
								}}
							>
								Ostoaika
							</Typography>
						</Stack>

						{!isMobile ? (
							<>
								<Stack
									sx={{ flex: 0.5 }}
									/* onClick={() => handleSort("order_id")} */
								>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										ID
									</Typography>
								</Stack>

								<Stack sx={{ flex: 1.5 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.name_label")}
									</Typography>
								</Stack>
								<Stack sx={{ flex: 2 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.reservation_type_label")}
									</Typography>
								</Stack>
								<Stack sx={{ flex: 1.5 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.reservation_date_label")}
									</Typography>
								</Stack>
								<Stack sx={{ flex: 1.5 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t(
											"orders.reservation_timerange_label"
										)}
									</Typography>
								</Stack>
								<Stack sx={{ flex: 1.5 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.total_label")}
									</Typography>
								</Stack>
								<Stack sx={{ flex: 1, alignItems: "center" }}>
									<Typography
										sx={{
											// marginLeft: "15px",
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700",
											width: "90px",
											textAlign: "center"
										}}
									>
										{t("orders.purchase_state_label")}
									</Typography>
								</Stack>
							</>
						) : (
							<>
								<Stack sx={{ flex: 1.5 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.name_label")}
									</Typography>

									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.reservation_type_label")}
									</Typography>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.reservation_date_label")}
									</Typography>
								</Stack>

								<Stack sx={{ flex: 1 }}>
									<Typography
										sx={{
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700"
										}}
									>
										{t("orders.total_label")}
									</Typography>
								</Stack>
								<Stack sx={{ flex: 1 }}>
									<Typography
										sx={{
											// marginLeft: "15px",
											fontSize: "11px",
											color: ColorScheme.black,
											fontWeight: "700",
											textAlign: "center",
											width: "90px"
										}}
									>
										{t("orders.purchase_state_label")}
									</Typography>
								</Stack>
							</>
						)}
					</Stack>
				</div>

				{!isLoading && cardOpen ? (
					orders.map((order, index) => (
						<ClientOrderCard
							key={order.order_id}
							data={order}
							user={user}
							index={index}
							handleOrder={handleSelectOrder}
						/>
					))
				) : (
					<div
						style={{
							display: !cardOpen && "none",
							padding: "20px"
						}}
					>
						<Spinner
							hasText={t("spinner_text.loading")}
							hasColor={ColorScheme.primary}
						/>
					</div>
				)}
			</Collapse>
		</Box>
	);
};

/* /* <DelayedRenderItem
							key={order.order_id}
							user={order}
							user={user}
							index={index}
							handleOrder={handleSelectOrder}
						/> */
